module.exports = __webpack_public_path__ + "img/jubilee.0f050d11.png";